/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

import type { ICollectionGroupOption } from 'volta/models/types/collection-view';

export interface CollectionViewGroupsSignature {
  Args: {
    options: ICollectionGroupOption[];
    groupLimit?: number;
    groupMin?: number;
    disabled?: boolean;
    onChange?: (groupBy: string[]) => void;
    onReorder?: (groupBy: string[]) => void;
  };
}

export default class CollectionViewGroupsComponent extends Component<CollectionViewGroupsSignature> {
  resourceName = { singular: 'attribute', plural: 'attributes' };

  handleSortEndAction = ([sortOptions]: string[][]) => {
    this.args.onReorder?.([...(sortOptions ?? [])]);
  };

  get isGroupMin() {
    if (!this.args.groupMin) {
      return false;
    }

    return this.args.options.filter((option) => option.selected).length <= this.args.groupMin;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'CollectionView::Groups': typeof CollectionViewGroupsComponent;
    'collection-view/groups': typeof CollectionViewGroupsComponent;
  }
}
